// Generated file - do not change manually!

/**
 * Types for the placement of message Popover control.
 */
export enum PopoverVerticalAlign {
  /**
   * Popover will be placed at the bottom of the reference control.
   */
  Bottom = 'Bottom',

  Center = 'Center',

  /**
   * Popover will be streched
   */
  Stretch = 'Stretch',

  /**
   * Popover will be placed at the top of the reference control.
   */
  Top = 'Top'
}
